// Library Imports
import { Popover } from 'antd';
import { ReactElement } from 'react';
import { TooltipPlacement } from 'antd/lib/tooltip';

// Local Imports
import ExclamationMark from '../../../assets/img/icons/Info.svg';
import ExclamationMarkError from '../../../assets/img/icons/ExclamationMarkError.svg';

type Props = {
  infoText: string | ReactElement;
  height?: number;
  width: number;
  placement?: TooltipPlacement | undefined;
  errorNode?: boolean;
  className?: string;
  popoverClass?: string;
  zindex?: number;
};

const InfoPopover = (props: Props) => {
  // Props
  const { infoText, width, height, placement, className, popoverClass, zindex } = props;

  return (
    <Popover
      placement={placement ? placement : 'top'}
      overlayStyle={{
        zIndex: zindex,
      }}
      overlayInnerStyle={{
        color: '#000000',
        fontFamily: 'Roboto',
        fontSize: 16,
        fontWeight: '500',
        lineHeight: 1.3,
        width: width,
        ...(height ? { height } : {}),
        boxShadow: '0px 2px 60px 0px rgba(0,0,0,0.35)',
        borderRadius: 10,
      }}
      overlayClassName={popoverClass ? popoverClass : ''}
      content={infoText}
    >
      <img className={`margin-right-sm ${className}`} src={props.errorNode ? ExclamationMarkError : ExclamationMark} alt="" />
    </Popover>
  );
};

export default InfoPopover;
